module.exports = __webpack_public_path__ + "static/media/push-platform.0e9ecac0.gif";